import { BrowserRouter, Route, RouterProvider, Routes } from "react-router-dom";
import {
  IonApp,
  IonContent,
  IonHeader,
  IonPage,
  setupIonicReact,
} from "@ionic/react";
import Home from "./pages/Home";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import { Category } from "./pages/Category";
import { Card } from "./pages/Card";
import { Cards } from "./pages/Cards";
import Dices from "./pages/Dices";
import Help from "./pages/Help";
import { TranslateProvider } from "./contexts/translate";
import { Header } from "./components/ui/Header";
import Credits from "./pages/Credits";
import { Redirect } from "react-router";

setupIonicReact();

const App: React.FC = () => {
  return (
    <TranslateProvider>
      <BrowserRouter>
        <IonApp>
          <IonPage>
            <Routes>
              <Route path="/cards" element={<Cards />} />
              <Route path="/cards/:type" element={<Category />} />
              <Route path="/cards/:type/:id" element={<Card />} />
              <Route path="/dices" element={<Dices />} />
              <Route path="/help" element={<Help />} />
              <Route path="/credits" element={<Credits />} />
              <Route path="/home" element={<Home />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </IonPage>
        </IonApp>
      </BrowserRouter>
    </TranslateProvider>
  );
};

export default App;
